import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import { columnDescription, columnName } from '@/constants/fields';
import { states } from '@/constants/lifecycle';
import TableWrapper from '@/components/table/TableWrapper';
import ActionDialogContent from '@/components/dialogs/ActionDialogContent';
import { deleteDataset, hideDeleteDataset } from '../actions';
import DatasetsTableColumns from './DatasetsTableColumns';
import DatasetsTableRows from '../components/DatasetsTableRows';

const DatasetDeletionDialog = ({
  hide,
  results,
  deleteData,
  theme,
}) => (
  <ActionDialogContent
    className="aridhia-dataset-deletion-dialog"
    inProgress={results.some((result) => result.destroyStatus === states.PENDING)}
    entities="datasets"
    entity="dataset"
    hide={hide}
    icon="table"
    identifiers={['catalogue.title']}
    items={results}
    onSubmit={deleteData}
    theme={theme}
  >
    <div className="aridhia-dialog-table-container">
      <TableWrapper sticky celled className="aridhia-datasets-table">
        <Table.Header fullWidth>
          <DatasetsTableColumns items={results} columns={[columnName, columnDescription]} />
        </Table.Header>
        <Table.Body>
          <DatasetsTableRows items={results} columns={[columnName, columnDescription]} theme={theme} />
        </Table.Body>
      </TableWrapper>
    </div>
  </ActionDialogContent>
);

const mapStateToProps = ({
  datasets: { datasets: { deletion: { results } } },
}) => ({ results });

const mapDispatchToProps = {
  hide: hideDeleteDataset,
  deleteData: deleteDataset,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetDeletionDialog);
